import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Header from './components/Header';
import PromotionalBanner from './components/PromotionalBanner';
import Hero from './components/Hero';
import AIChallenges from './components/AIChallenges';
import Introducing from './components/Introducing';
import Benefits from './components/Benefits';
import Testimonials from './components/Testimonials';
import About from './components/About';
import Booking from './components/Booking';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import TermsOfUse from './components/TermsOfUse';
import PrivacyPolicy from './components/PrivacyPolicy';
import PostSessionNotes from './components/PostSessionNotes';
import FormModern from './components/FormModern';
import Success from './components/Success';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <>
            <PromotionalBanner />
            <AppContainer>
              <Header />
              <Hero />
              <AIChallenges />
              <Introducing />
              <Benefits />
              <Testimonials />
              <About />
              <Booking />
              <FAQ />
              <Footer />
            </AppContainer>
          </>
        } />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/postsessionnotes" element={<PostSessionNotes />} />
        <Route path="/form" element={<FormModern />} />
        <Route path="/success" element={<Success />} />
      </Routes>
    </Router>
  );
}

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export default App;
